import { EVENT_TYPES } from './constants.js';

function emit(type, value, meta) {
    const detail = { value, meta };
    window.dispatchEvent(new CustomEvent(type, { detail }));
}

function on(type, handler) {
    const listener = (e) => handler(e.detail.value, e.detail.meta);
    window.addEventListener(type, listener);
    return () => window.removeEventListener(type, listener);
}

// Tracking whether one-time events have occurred for late subscribers
let readyEventHasEmitted = false;
let pricingLoadedHasEmitted = false;

// Cache values sent to already occurred events for late subscribers
let readyEventData;

const events = {
    ready: {
        subscribe: (handler) => {
            if (readyEventHasEmitted) {
                handler(readyEventData?.value);
            }
            return on(EVENT_TYPES.READY, handler);
        },
        emit: (value) => {
            readyEventData = { value };
            emit(EVENT_TYPES.READY, value);
            readyEventHasEmitted = true;
        },
    },
    pricingLoaded: {
        subscribe: (handler) => {
            if (pricingLoadedHasEmitted) {
                handler();
            }
            return on(EVENT_TYPES.PRICING_LOADED, handler);
        },
        emit: () => {
            emit(EVENT_TYPES.PRICING_LOADED);
            pricingLoadedHasEmitted = true;
        },
    },
    cookieUpdate: {
        subscribe: (handler) => on(EVENT_TYPES.COOKIE_UPDATE, handler),
        emit: (value) => emit(EVENT_TYPES.COOKIE_UPDATE, value),
    },
    openCart: {
        subscribe: (handler) => on(EVENT_TYPES.OPEN_CART, handler),
        emit: () => emit(EVENT_TYPES.OPEN_CART),
    },
    closeCart: {
        subscribe: (handler) => on(EVENT_TYPES.CLOSE_CART, handler),
        emit: () => emit(EVENT_TYPES.CLOSE_CART),
    },
    toggleCart: {
        subscribe: (handler) => on(EVENT_TYPES.TOGGLE_CART, handler),
        emit: () => emit(EVENT_TYPES.TOGGLE_CART),
    },
};

export default events;
